export const REPLACE_BKOUSERS = 'REPLACE_BKOUSERS';
export const ADD_BKOUSER = 'ADD_BKOUSER';
export const UPDATE_BKOUSER = 'UPDATE_BKOUSER';